import $ from "jquery";

window.$ = window.jQuery = $;

require("jquery-ujs");
require("@activeadmin/activeadmin/src/base.js");
